import { from, Observable } from 'rxjs';
import { USER_ID_KEY } from '../constants';
import { StorageService } from '../services';
import { ModulesService } from '../services/modules/modules.service';
import { CompanyModuleService } from '../services/company';
import { PermissionService } from '../services/permissions';
import { catchError, concatMap, filter, take } from 'rxjs/operators';

export function moduleInitializer(
  modulesService: ModulesService,
  companyModuleService: CompanyModuleService,
  permissionService: PermissionService
): () => Observable<unknown> {
  const isUserLogged = !!StorageService.GetItem(USER_ID_KEY);

  if (!isUserLogged) {
    const el = () =>
      new Observable((obs) => {
        obs.next(null);
        obs.complete();
      });

    return el;
  }

  return () =>
    permissionService.permissions$.pipe(
      filter((permissions) => permissions !== null),
      take(1),
      concatMap(() => modulesService.init()),
      concatMap(() => from(companyModuleService.init())),
      catchError(() => {
        return new Observable((obs) => {
          obs.next(null);
          obs.complete();
        });
      })
    );
}
